/**
 * @bos/portal3 — React 19 entry point. Builds the browser (history) router from the
 * route table and mounts it. `createBrowserRouter` + `RouterProvider` is what makes
 * every route a real URL with working Back / Forward / Refresh.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from './routes';
import { AuthProvider } from './auth/AuthContext';
import './styles.css';

const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('@bos/portal3: #root element missing from index.html');
}

const router = createBrowserRouter(routes);

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
